import api from "./api";

export const productService = {
  // Get all products
  getProducts: async (params = {}) => {
    const response = await api.get("/api/products", { params });
    return response.data.data || response.data;
  },

  // Get product by ID
  getProductById: async (id) => {
    const response = await api.get(`/api/products/${id}`);
    return response.data.data || response.data;
  },

  // Get product images
  getProductImages: async (id) => {
    const response = await api.get(`/api/products/${id}/images`);
    return response.data.data || response.data;
  },

  // Create product with multiple file uploads
  createProduct: async (productData, imageFiles = []) => {
    const formData = new FormData();

    // Add all product data fields to FormData
    Object.keys(productData).forEach(key => {
      if (productData[key] !== undefined && productData[key] !== null) {
        formData.append(key, productData[key]);
      }
    });

    // Add multiple image files if provided
    if (imageFiles && imageFiles.length > 0) {
      imageFiles.forEach((file) => {
        formData.append("images", file);
      });
    }

    const response = await api.post("/api/products", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data.data || response.data;
  },

  // Update product with multiple file uploads
  updateProduct: async (
    productId,
    productData,
    imageFiles = [],
    removedImageUrls = []
  ) => {
    const formData = new FormData();

    // Add all product data fields to FormData
    Object.keys(productData).forEach(key => {
      if (productData[key] !== undefined && productData[key] !== null) {
        formData.append(key, productData[key]);
      }
    });

    // Add multiple image files if provided
    if (imageFiles && imageFiles.length > 0) {
      imageFiles.forEach((file) => {
        formData.append("images", file);
      });
    }

    // Add removed image URLs
    if (removedImageUrls && removedImageUrls.length > 0) {
      formData.append("removedImageUrls", JSON.stringify(removedImageUrls));
    }

    const response = await api.put(`/api/products/${productId}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data.data || response.data;
  },

  // Delete product
  deleteProduct: async (productId) => {
    const response = await api.delete(`/api/products/${productId}`);
    return response.data.data || response.data;
  },

  // Get vendor dashboard stats
  getDashboardStats: async () => {
    const response = await api.get("/api/vendor/dashboard/stats");
    return response.data.data || response.data;
  },

  // Get product statistics
  getProductStats: async (productId) => {
    const response = await api.get(`/api/products/${productId}/stats`);
    return response.data.data || response.data;
  },
};

export default productService;
